<template>
  <div class="part">
    <div class="layout-page-heading">
      <div class="iconClock">
        <img src="../../assets/img/iconAccount.png" alt="">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>账号管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="layout-page-box">
      <el-form :inline="true" label-width="80px" label-position="right" class="search-form">
        <el-form-item label="姓名">
          <el-input v-model="filters.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input v-model="filters.mobile" clearable></el-input>
        </el-form-item>
        <el-form-item label="用户名">
          <el-input v-model="filters.account" clearable></el-input>
        </el-form-item>
        <el-form-item label="部门名称">
          <el-select v-model="filters.departmentId" @focus="departmentFocus" :remote-method="departmentRemoteMethod" filterable remote clearable placeholder="请输入搜索部门" style="width:90%">
            <el-option v-for="item in departmentOptions" :key="item.departmentId" :label="item.departmentName" :value="item.departmentId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区域">
          <el-select :disabled="cityDis" v-model="filters.cityCode" clearable>
            <el-option v-for="item in citys" :key="item.cityCode" :label="item.name" :value="item.cityCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item class="checkButton">
          <el-button type="primary" @click="query(1)">查询</el-button>
        </el-form-item>
      </el-form>
      <div class=" buttonText">
        <div class="delete" @click="del">删除</div>
        <div class="addData" @click="add">新增</div>
      </div>
    </div>

    <div class="layout-page-box">
      <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" height="460" :header-cell-style="{color:'#626365'}">
        <el-table-column type="selection" width="55">
        </el-table-column>
        <el-table-column prop="account" label="用户名"></el-table-column>
        <el-table-column prop="userName" label="姓名"></el-table-column>
        <el-table-column prop="mobile" label="手机号"></el-table-column>
        <el-table-column prop="postName" label="岗位名称"></el-table-column>
        <el-table-column prop="departmentName" label="部门名称"></el-table-column>
        <el-table-column prop="cityName" label="区域"></el-table-column>
        <el-table-column prop="systemType" label="系统类型">
          <template slot-scope="scope">
            <div v-for="(item,index) in scope.row.systemType.split(',')" :key='index'>
              <span v-if="item==1">预约</span>
              <span v-if="item==2">扫码</span>
              <span v-if="item==3">报表</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="delFlg" label="是否禁用">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.delFlg" active-color="#13ce66" inactive-color="#eee" @change="onChange(scope.$index, scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="添加时间"></el-table-column>
        <el-table-column align="center" label="操作" width="130">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)" :disabled="scope.row.delFlg==true?true:false">编辑</el-button>
            <el-button size="mini" type="warning" @click="handleCreate(scope.$index, scope.row)" :disabled="scope.row.delFlg==true?true:false" v-if="scope.row.doctorNo==null">生成账号</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change="handleSizeChange" @current-change="pageChanged" :current-page="filters.pagination.page" :page-size="filters.pagination.limit" :page-sizes="[10, 20, 30, 50]" layout="total, sizes,prev, pager, next, jumper" :total="filters.pagination.total">
      </el-pagination>
    </div>
    <el-dialog :visible.sync="dialogFormVisible" center class="dialogItem" :close-on-click-modal="false">
      <el-form :model="formData" label-width="120px">
        <el-form-item label="区域">
          <el-select :disabled="cityDis" v-model="formData.cityCode" style="width: 90%">
            <el-option v-for="(item,index) in citys" :key="index" :label="item.name" :value="item.cityCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="formData.userName" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="mobile">
          <el-input v-model="formData.mobile" style="width: 90%" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item label="部门">
          <el-select v-model="formData.departmentId" @focus="departmentFocus" :remote-method="departmentRemoteMethod" filterable remote clearable placeholder="请输入搜索部门" style="width:90%">
            <el-option v-for="(item,index) in departmentOptions" :key="index" :label="item.departmentName" :value="item.departmentId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="岗位名称">
          <el-input v-model="formData.postName" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item label="系统类型">
          <el-select v-model="formData.systemType" style="width: 90%" :disabled="disabled" multiple>
            <el-option v-for="(item,index) in system" :key="index" :label="item.name" :value="item.systemType">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer partFooter">
        <el-button type="danger" @click="closs()">取 消</el-button>
        <el-button type="primary" @click="doAddgoods()">{{buttonName}}</el-button>
      </div>
      <div class="cardBox">
        <el-card class="box-card" v-if="boxCard">
          <span class="closeAdd">
            <i class="el-icon-close" @click="closeDialog"></i>
          </span>
          <div>
            <el-form :model="formList" label-width="120px">
              <el-form-item label="用户名:">
                <div>{{formList.account}}</div>
              </el-form-item>
              <el-form-item label="初始密码:">
                <div>{{formList.password}}</div>
              </el-form-item>
            </el-form>
            <div class="accountAdd">
              <el-button type="danger" @click="copy(formList.account)">复制</el-button>
              <el-button type="primary" @click="dialogFormVisible=false">确定</el-button>
            </div>
          </div>
        </el-card>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="accountDialog" center class="dialogItem" :close-on-click-modal="false">
      <el-form :model="dialogData" label-width="120px">
        <el-form-item label="包含员工">
          <el-select default-first-option filterable multiple v-model="dialogData.subordinate" style="width: 90%" @input="testSX" :filter-method="empMatch">
            <el-option v-for="(item) in lists" :key="item.id" :label="item.userName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer partFooter">
        <el-button type="danger" @click="accountDialog=false">取 消</el-button>
        <el-button type="primary" @click="sure()">生成账号</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pinyin from 'pinyin-match'
export default {
  name: "member",
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else if (value.length != 11) {
        return callback(new Error('手机号长度不正确'));
      } else if (isNaN(value)) {
        return callback(new Error('手机号格式不正确'));
      }
    };
    return {
      dialogData: {},
      filters: {
        types: '',
        pagination: {
          page: 1,
          limit: 10,
          total: 0
        },
        startTime: '',
        endTime: '',
      },
      formData: {
        positionName: "",
      },
      tableData: [],
      multipleSelection: [],
      dialogFormVisible: false,
      accountDialog: false,
      accountId: '',
      departmentOptions: [],
      boxCard: false,
      formList: {},
      value: true,
      buttonName: '',
      rules: {
        mobile: [{
          validator: checkPhone,
          trigger: 'blur'
        }]
      },
      system: [{
        name: '预约',
        systemType: '1'
      },
      {
        name: '扫码',
        systemType: '2'
      },
      {
        name: '报表',
        systemType: '3'
      },
      ],
      disabled: false,
      listType: Lockr.get("systemType"),
      citys: [
        {
          name: '南通',
          cityCode: 2
        },
        {
          name: '上海',
          cityCode: 1
        },
      ],
      cityCode: Lockr.get('cityCode'),
      cityDis: false,
      lists: [],
      copyLists: [],
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    pageChanged(page) {
      this.filters.pagination.page = page
      this.refresh()
    },
    handleSizeChange(sizes) {
      this.filters.pagination.limit = sizes
      this.refresh()
    },
    refresh() {
      router.push({
        path: this.$route.path,
        query: _.merge({}, this.$route.query, {
          __query: JSON.stringify(this.pagination)
        }, {
            random: Math.random()
          })
      })
    },
    closeDialog() {
      this.boxCard = false
    },
    // 新增账号
    add() {
      this.dialogFormVisible = true
      this.formList = ''
      this.boxCard = false
      if (this.listType != '') {
        // 新增置空
        this.formData = {
          cityCode: this.cityCode,
          systemType: this.listType.split(',')
        }
      } else if (this.listType == '') {
        this.formData = {
          cityCode: this.cityCode,
          systemType: ''
        }
      }
      this.accountId = ''
      this.buttonName = '生成账号'
    },
    // 删除账号
    del() {
      var data = this.multipleSelection
      var id = []
      data.map(function (item, index) {
        id.push(item.id)
      })
      this.$confirm('确定要删除选中的数据吗？', '删除账号', {
        center: true
      })
        .then((res) => {
          api.requestQuiet("/account/deleteEmployeeInfoByIds", {
            ids: id.toString()
          }, (res) => {
            if (res.result == true) {
              _g.toast("success", "删除成功")
              this.query(this.filters.pagination.page)
            } else {
              _g.toast("error", "删除失败")
              this.query(this.filters.pagination.page)
            }
          }, (err) => { })
        }).catch((err) => {
          // this.$message.error('删除失败！');
        })

    },
    closs() {
      this.dialogFormVisible = false
    },
    // 确定新增
    doAddgoods() {
      //请求新增账号接口
      let empId = Lockr.get("empId")
      console.log(empId)
      if (!this.accountId) {
        // 新增账号接口
        let data = {
          userName: this.formData.userName,
          departmentId: this.formData.departmentId,
          postName: this.formData.postName,
          userId: empId,
          moblie: this.formData.mobile,
          // 新建账号0新建操作人1
          status: 0,
          systemType: this.formData.systemType.toString(),
          cityCode: this.formData.cityCode,
        }
        api.request("/account/createPersonnelLogin", data, (res) => {
          if (res.result == true) {
            console.log(res.data)
            _g.toast("success", "新增成功")
            this.boxCard = true
            this.formList = res.data
            this.formList.password = '000000'
            // this.dialogFormVisible = false
            this.query(this.filters.pagination.page)
          } else {
            _g.toast("error", "新增失败")
            this.query(this.filters.pagination.page)
          }
        }, (err) => { })
      } else {
        // 修改账号接口
        let data = {
          empId: this.formData.id,
          userName: this.formData.userName,
          departmentId: this.formData.departmentId,
          postName: this.formData.postName,
          userId: empId,
          moblie: this.formData.mobile,
          status: 0,
          systemType: this.formData.systemType.toString(),
          cityCode: this.formData.cityCode,
        }
        api.request("/account/updatePersonnelLogin", data, (res) => {
          if (res.result == true) {
            this.dialogFormVisible = false
            _g.toast("success", "修改成功")
            this.query(this.filters.pagination.page)
          } else {
            this.dialogFormVisible = false
            _g.toast("error", "修改失败")
            this.query(this.filters.pagination.page)
          }
        }, (err) => { })
      }
    },
    handleEdit(index, row) {
      console.log(row)
      this.boxCard = false
      this.dialogFormVisible = true
      this.accountId = row.id
      this.buttonName = '确定'
      row.departmentId = parseInt(row.departmentId)
      this.formData = JSON.parse(JSON.stringify(row))
      this.formData.systemType = this.formData.systemType.split(',')
      // this.formData.subordinate = this.formData.subordinate.map(Number)
      this.departmentFocus()
    },
    handleCreate(index, row) {
      console.log(row)
      this.accountDialog = true
      this.dialogData = row
    },
    sure() {
      let empId = Lockr.get("empId")
      let data = {
        password: this.dialogData.password,
        userName: this.dialogData.userName,
        moblie: this.dialogData.mobile,
        empId: this.dialogData.id,
        account: this.dialogData.account,
        departmentId: this.dialogData.departmentId,
        systemType: this.dialogData.systemType,
        subordinate: this.dialogData.subordinate.toString(),
      }
      api.request("/personnel/createPhoneAccount", data, (res) => {
        if (res.result == true) {
          _g.toast("success", "账号生成成功")
          this.accountDialog = false
          this.query(this.filters.pagination.page)
        } else {
          _g.toast("error", "账号生成失败")
          this.query(this.filters.pagination.page)
        }
      }, (err) => { })
    },
    testSX() {
      this.$forceUpdate()
    },
    // 禁用操作
    onChange(index, row) {
      console.log(row.delFlg)
      let data = {
        empId: row.id,
        // 0：启用  1：禁用
      }
      if (row.delFlg == false) {
        data.isDisable = 0
      } else if (row.delFlg == true) {
        data.isDisable = 1
      }
      api.request("/account/toEmployeeInfoDisable", data, (res) => {
        if (res.result == true) {
          _g.toast("success", "状态修改成功")

          this.query(this.filters.pagination.page)
        } else {
          _g.toast("error", "状态修改失败")
          this.query(this.filters.pagination.page)
        }
      }, (err) => { })
    },
    // 查询部门
    departmentRemoteMethod(val) {
      let data = {
        name: val
      }
      api.request('/department/findDepartments', data, (res) => {
        // console.log(res)
        this.departmentOptions = res.data
      }, (err) => { })
    },
    departmentFocus() {
      let data = {
        name: ''
      }
      api.request('/department/findDepartments', data, (res) => {
        // console.log(res)
        this.departmentOptions = res.data
      }, (err) => { })
    },
    // 查询数据列表
    query(page) {
      // console.log(this.filters.startTime)
      var querys = {
        accountName: this.filters.account,
        departmentId: this.filters.departmentId,
        page: page,
        size: this.filters.pagination.limit,
        mobile: this.filters.mobile,
        name: this.filters.name,
        cityCode: this.filters.cityCode,
      }
      if (Lockr.get("systemType") == '1' || Lockr.get("systemType") == '2') {
        querys.systemType = Lockr.get("systemType")
      }
      api.requestQuiet('/account/findEmployeeInfoPage', querys, (res) => {
        // console.log(res)
        var data = res.data.list
        this.tableData = data
        this.orgData = data
        this.filters.pagination.total = parseInt(res.data.total)
        // api.request("personnel/findEmployeeInfoAll", {}, (res) => {
        //   this.copyLists = res.data
        //   this.lists = res.data
        // }, (err) => { })
      }, (err) => { })
    },
    // 点击复制
    copy(data) {
      let url = data;
      let oInput = document.createElement('input');
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value)
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message({
        message: '复制成功',
        type: 'success'
      });
      oInput.remove()
    },
    empMatch(val) {
      if (val) { //val存在
        this.lists = this.copyLists.filter((item) => {
          // 如果直接包含输入值直接返回true
          if (item.userName) {
            if (item.userName.toUpperCase().indexOf(val.toUpperCase()) != -1) {
              return true
            }
            // 输入值拼音d
            return pinyin.match(item.userName, val)
          }
        })
      } else { //val为空时，还原数组
        this.lists = this.copyLists
      }
    },

  },
  mounted() {
    /*this.init();*/
    // 判断账号系统类型
    if (this.listType == 'null') {
      this.listType = ''
      this.disabled = false
    } else if (this.listType == '1' || this.listType == '2') {
      this.disabled = true
    }
    // 判断账号区域
    if (this.cityCode && this.cityCode != 'null') {
      this.filters.cityCode = Lockr.get("cityCode")
      this.cityDis = true
    } else {
      this.cityDis = false
    }
    // 初始化数据
    this.query(this.filters.pagination.page)
  },
  created() {
    api.request("personnel/findEmployeeInfoAll", {}, (res) => {
      this.copyLists = res.data
      this.lists = res.data
    }, (err) => { })
  },
  watch: {
    '$route'(to, from) {
      this.query(this.filters.pagination.page)
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/main.css";

.sp1 {
  display: block;
}

.p1 {
  display: inline-block;
  color: #6e6e6e;
  font-size: 20px;
}

.p2 {
  display: inline-block;
  font-size: 20px;
  color: #000000;
  padding-left: 20px;
}

.part >>> .el-dialog--center .el-dialog__body {
  text-align: center;
}

.dialogItem >>> .el-input__inner {
  height: 34px;
  background: #ffffff;
  /* box-shadow: 0px 0px 5px 3px #CAEAFD; */
  border-radius: 3px;
  /* border: 1px solid #23A2EE; */
}

.dialogItem >>> .el-form-item__label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #626365;
}

.partFooter >>> .el-button--primary {
  width: 125px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.checkButton >>> .el-button--primary {
  width: 98px;
  height: 34px;
  background: #5a7ef8;
  border-radius: 17px;
  line-height: 5px;
}

.partFooter >>> .el-button--danger {
  width: 125px;
  height: 34px;
  border-radius: 17px;
  border: 1px solid #5a7ef8;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5a7ef8;
  line-height: 2px;
  background: none;
}

.pageInput >>> .el-input__inner {
  width: 400px;
  height: 38px;
  background: #f6f7fb;
  border-radius: 23px;
  border: none;
}

.pageInput >>> .el-button {
  height: 34px;
  border-radius: 17px;
  border: 1px solid #979797;
  line-height: 5px;
  margin-left: 8px;
}

.part >>> .el-card {
  width: 360px;
  /* height: 160px; */
}

.accountAdd >>> .el-button--danger {
  width: 77px;
  height: 28px;
  border-radius: 100px;
  border: 1px solid #5a7ef8;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #5a7ef8;
  line-height: 0px;
  background: none;
}

.accountAdd >>> .el-button--primary {
  width: 77px;
  height: 28px;
  background: #5a7ef8;
  border-radius: 100px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 0;
}

.closeAdd {
  display: flex;
  justify-content: flex-end;
}

.closeAdd i {
  cursor: pointer;
}

.cardBox {
  display: flex;
  justify-content: center;
}

.iconClock {
  display: flex;
  align-items: center;
}

.iconClock img {
  height: 20px;
  margin-right: 5px;
}

.part >>> .el-select .el-input.is-disabled .el-input__inner {
  color: #606266;
}
</style>